import Input from 'antd/es/input/Input';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store/store';
import { updateExamRequest } from '../../../redux/slice/examEditSlice';
import { Select, Switch } from 'antd';
import { approvalStatusList, examTypeList } from 'utils/enumMapper';
import {
  useExamEditExamRequestSelector,
  useExamEditPractice,
  useExerciseFormatsSelector,
  useMasterSchoolYearsSelector,
  useMasterSubjectsSelector,
  useMasterUserSelector,
} from '../../../redux/selector';
import { cloneDeep } from 'lodash';
import { canMasterCompile } from '../../../utils/utils';
import TextArea from 'antd/es/input/TextArea';

export default function EditExamView() {
  const examRequest = useExamEditExamRequestSelector();
  const dispatch = useDispatch<AppDispatch>();
  const exerciseFormats = useExerciseFormatsSelector();
  const schoolYearList = useMasterSchoolYearsSelector();
  const subjectList = useMasterSubjectsSelector();
  const practice = useExamEditPractice();
  const user = useMasterUserSelector();

  const onChangeInput = function (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>,
    filedName: string,
  ) {
    const examRequestTemp = cloneDeep(examRequest) as any;
    examRequestTemp[filedName] = e.target.value;
    dispatch(updateExamRequest(examRequestTemp));
  };

  const handleChangeFree = (checked: boolean) => {
    const examRequestTemp = cloneDeep(examRequest);
    if (examRequestTemp) {
      examRequestTemp.free = checked;
      dispatch(updateExamRequest(examRequestTemp));
    }
  };

  const onChangeSelect = function (e: any, fieldName: string) {
    const examRequestTemp = cloneDeep(examRequest) as any;
    switch (fieldName) {
      case 'schoolYear':
        examRequestTemp.schoolYear = {
          id: e,
        };
        break;
      case 'subject':
        examRequestTemp.subject = {
          id: e,
        };
        break;
      case 'exerciseFormats':
        examRequestTemp.exerciseFormats = e.map((item: any) => ({
          id: item,
        }));
        break;
      default:
        examRequestTemp[fieldName] = e;
        break;
    }

    dispatch(updateExamRequest(examRequestTemp));
  };

  const getExerciseFormat = useMemo(() => {
    if (!examRequest) return [];
    return examRequest.exerciseFormats ? examRequest.exerciseFormats.map((item) => item.id) : [];
  }, [examRequest?.exerciseFormats]);

  const getOptionExerciseFormats = useMemo(() => {
    return exerciseFormats
      .filter((item) => {
        if (examRequest?.subject) {
          return item.subject.id === examRequest?.subject.id;
        }
        return true;
      })
      .map((item) => ({
        value: item.id,
        label: `${item.code}-${item.name}`,
      }));
  }, [exerciseFormats, examRequest?.subject]);

  return (
    <div className="w-full h-full p-4 flex flex-col">
      <div className="flex-1">
        <div className="flex items-center">
          <div className="text-[18px] w-[20%] text-left">Tên đề:</div>
          <Input
            placeholder="Tên đề"
            name="title"
            className="w-fit"
            defaultValue={examRequest?.name}
            maxLength={255}
            onChange={(e) => onChangeInput(e, 'name')}
          />
        </div>
        {!practice ? (
          <div className="flex items-center mt-2">
            <div className="text-[18px] w-[20%] text-left">Thời gian làm bài:</div>
            <Input
              className="w-[90px]"
              type="number"
              name="duration"
              value={examRequest?.duration}
              onChange={(e) => onChangeInput(e, 'duration')}
            />
            <div className="ml-4">giây</div>
          </div>
        ) : null}
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Mã đề:</div>
          <Input
            placeholder="Mã đề"
            name="code"
            className="w-fit"
            value={examRequest?.code}
            maxLength={255}
            onChange={(e) => onChangeInput(e, 'code')}
          />
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Mức ưu tiên:</div>
          <Input
            className="w-[90px]"
            type="number"
            name="priority"
            value={examRequest?.priority}
            onChange={(e) => onChangeInput(e, 'priority')}
          />
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Loại đề thi:</div>
          <div className="min-w-[300px] max-w-[300px]">
            <Select
              onChange={(e) => onChangeSelect(e, 'type')}
              className="w-full"
              placeholder="Loại đề thi"
              style={{ flex: 1 }}
              value={examRequest?.type}
              options={examTypeList}
            />
          </div>
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Trạng thái kiểm duyệt:</div>
          <div className="min-w-[300px] max-w-[300px]">
            <Select
              onChange={(e) => onChangeSelect(e, 'approvalStatus')}
              className="w-full"
              placeholder="Trạng thái kiểm duyệt"
              style={{ flex: 1 }}
              value={examRequest?.approvalStatus}
              options={approvalStatusList}
              disabled={!canMasterCompile(user?.role)}
            />
          </div>
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Số điểm sử dụng:</div>
          <Input
            className="w-[90px]"
            type="number"
            name="requiredTicketCount"
            value={examRequest?.requiredTicketCount}
            onChange={(e) => onChangeInput(e, 'requiredTicketCount')}
          />
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Khóa:</div>
          <div className="min-w-[300px] max-w-[300px]">
            <Select
              onChange={(e) => onChangeSelect(e, 'schoolYear')}
              className="w-full"
              placeholder="Khóa"
              style={{ flex: 1 }}
              value={examRequest?.schoolYear?.id}
              options={schoolYearList.map((schoolYear) => ({
                value: schoolYear.id,
                label: schoolYear.name,
              }))}
            />
          </div>
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Môn học:</div>
          <div className="min-w-[300px] max-w-[300px]">
            <Select
              onChange={(e) => onChangeSelect(e, 'subject')}
              className="w-full"
              placeholder="Môn học"
              style={{ flex: 1 }}
              value={examRequest?.subject?.id}
              options={subjectList.map((subject) => ({
                value: subject.id,
                label: subject.name,
              }))}
              disabled={true}
            />
          </div>
        </div>
        <div className={'flex items-center mt-2 ' + (practice ? '' : 'hidden')}>
          <div className="text-[18px] w-[20%] text-left">Dạng bài tập:</div>
          <div className=" min-w-[300px] max-w-[300px]">
            <Select
              mode="multiple"
              onChange={(e) => onChangeSelect(e, 'exerciseFormats')}
              className="w-full"
              placeholder="Dạng bài tập"
              style={{ flex: 1 }}
              value={getExerciseFormat}
              options={getOptionExerciseFormats}
            />
          </div>
        </div>
        <div className={'flex items-center mt-2 ' + (practice ? 'hidden' : '')}>
          <div className="text-[18px] w-[20%] text-left">Mô tả:</div>
          <TextArea
            placeholder="Mô tả"
            name="title"
            className="w-1/2"
            defaultValue={examRequest?.description}
            onChange={(e) => onChangeInput(e, 'description')}
          />
        </div>
        <div className={'flex items-center mt-2 ' + (practice ? 'hidden' : '')}>
          <div className="text-[18px] w-[20%] text-left">Đề miễn phí:</div>
          <Switch checked={examRequest?.free} onChange={handleChangeFree} />
        </div>
      </div>
    </div>
  );
}
